    <template>
      <div>
   <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
      <v-navigation-drawer 
          temporary
          v-model="notificationDrawer"  
          hide-overlay
          floating         fixed app
          right :clipped="$vuetify.breakpoint.lgAndUp">
            <v-toolbar flat class="transparent">
              <v-list class="pa-0">
                <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Notifications</v-list-tile-title>
                    </v-list-tile-content>
                        <v-icon @click="AddNotification()">add</v-icon>
               </v-list-tile>

                        <v-dialog v-model="popup" width="800px">
                          <v-card>
                            <v-card-title
                            class="grey lighten-4 py-4 title"
                            >
                            Create Notification
                            </v-card-title>

                             <v-container grid-list-sm class="pa-4">
                                <v-layout row wrap>
                                  <v-flex xs12>
                                  <v-text-field
                                  label="Title"
                                  placeholder="Title"
                                  v-model="notifications.title">
                                 
                                  </v-text-field>
                                  </v-flex>

                                  <v-flex xs12>
                                  <v-text-field
                                  label="Meassage"
                                  placeholder="Meassage"
                                  v-model="notifications.message"
                                  ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12>
                                  <v-text-field
                                  label="Attachment"
                                  placeholder="Attachment"
                                  v-model="notifications.attachments"
                                  ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12>                                 
                                  <v-autocomplete
                                  
                                  label="User List"
                                  placeholder="User List"
                                  type="text"
                                  
                                  item-text="username"
                                  item-value="id"
                                  :items="Users"
                                  v-model="notifications.users"
                                  
                                  ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs12>
                                  <v-checkbox
                                  label="read Receipt"
                                  v-model="notifications.read_receipt"
                                  ></v-checkbox>
                                  </v-flex>
                                 
                                 </v-layout>
                                </v-container>
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="popup = false">Cancel</v-btn> 
                                <v-btn flat @click="save()">Save</v-btn>
                                </v-card-actions>

                                </v-card>
                                </v-dialog>
                        </v-list>
                        </v-toolbar>

                      <v-list class="pt-0" dense>
                        <v-divider></v-divider>
                          <v-list-tile
                          v-for="notification in notifications"
                          :key="notification.title"
                          @click=""
                          >
                              <v-list-tile-action>
                              <v-icon v-if="notification.type=='I'">fa fa-info</v-icon>
                              <v-icon v-if="notification.type=='W'">fa fa-warning</v-icon>
                              </v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title @click="showInfo(notification)">{{ notification.title }}</v-list-tile-title>
                                </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                      </v-navigation-drawer> 
  
                        <v-dialog
                        v-model="dialog"
                        width="500"
                        >
                        <v-card>
                        <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                        >
                        Notification
                        </v-card-title>
                        {{message.title}}
                        <v-card-text>

                        </v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        color="primary"
                        flat
                        @click.stop="dialog=!dialog"
                        >
                        Cancel
                        </v-btn>
                        </v-card-actions>
                        <v-divider></v-divider>

                        </v-card>
                        </v-dialog>
              </div>
              </template>
                    <script>
                    
                    import NotificationModel from '@/api/service/NotificationService';
                    import UserModel from '@/api/service/UserService';
                    import NotificationBox from './NotificationBox.vue'
                    export default {
                      name:"NotificationList",
                      components: {
                        NotificationBox
                      },
                      props: [
                        "notificationDrawer"
                      ],
                      data()  { 
                        
                        return {
                          message:{},

                          ntfy:true,
                          dialog:false,
                          popup:false,
                          notificationContent:'',
                           Users:[],
                          notifications:[

                            {"id":123,"title":"Show Temp",type:"I"},
                            {"id":123,"title":"Warning",type:"W"},
                            {"id":123,"title":"Crititcal",type:"C"}

                          ],
                         
                        }
                      },
                    watch : {
                      ntfy() {
                        console.log(this.ntfy)
                      }
                    },
                    computed: {
                      checkNotification() {

                        // this.showNotification = this.$store.getters.showNotification
                      }
                    },
                      // created: function() {
                      //   NotificationModel.findAll({})
                      //         .then(response => {
                      //             this.setNotification(response)                
                      //         }).catch(error => {
                      //             console.log(error)
                      //     }); 

                      // },
                     
                    
                      methods: {
                          // setNotification($x){
                          //   this.notifications = $x;
                          // },
                          setUsers($Users){
                          this.Users = $Users;
                          },
                          showInfo($item)
                          {
                            this.notificationContent=$item
                            this.message= $item
                            this.dialog=true 
                            
                          },
                          invisibleDialog() {
                            this.dialog=false
                          },
                          Shownotificationbar()
                          {
                            this.shownotification=! this.shownotification;
                          },
                          notificationListStopped() {
                            this.$parent.$emit('NotificationTransitionEnd')
                          },

                          AddNotification()
                          {

                          this.popup =  true
                          UserModel.findAllUserList({})
                            .then(response => {
                                this.setUsers(response)               
                            }).catch(error => {
                                console.log(error)
                          }); 
                          },
                          save () {
                          var navigate = this.$router;
                          var stores = this.$store;
                          // console.log(localStorage)  
                          NotificationModel.CreateNotification(this.notifications)
                          .then(response => {
                          navigate.replace('/mapheaders')

                          }).catch(error => {
                          console.log(error);
                          console.log('I am getting error')
                          //alert(error);
                          }); 
                         
                          },
                    }
                      
                    }

                    </script>